<div class="popular-stores d-flex flex-column align-items-stretch justify-content-start gap-atom">
  <div class="px-plus">
    <common-ui-components-title-summary
      [isLoading]="isLoading()"
      [title]="'فروشگاه‌های محبوب'"
      [showButton]="false"
    ></common-ui-components-title-summary>
  </div>
  <div class="px-atom">
    <common-ui-components-horizontal-scroll [classes]="'pr-plus'">
      @if (isLoading()) {
        @for (item of rangeCreator(4); track $index) {
          <daily-stores-store-preview [isLoading]="true"></daily-stores-store-preview>
        }
      } @else {
        @for (store of popularStores(); track $index) {
          <daily-stores-store-preview
            [classes]="'cursor-pointer'"
            (click)="handleItemClick(store)"
            [store]="store"
          ></daily-stores-store-preview>
        }
      }
    </common-ui-components-horizontal-scroll>
  </div>
</div>
